<template>
  <div class="h-full" :class="[`bg-${$route.meta.background}`]">
    <eggos
      v-if="$route.meta.eggos !== undefined"
      :color="$route.meta.eggos"
    ></eggos>
    <div class="page-404">
      <div class="page-404__logo">
        <img src="@/assets/images/brand/logo.svg" />
        <h3 class="page-404__title">{{ $t("page404.title") }}</h3>
        <p v-if="noPreview" class="page-404__desc">{{ $t("page404.noPreviewDesc") }}</p>
        <p v-else class="page-404__desc">{{ $t("page404.desc2") }}</p>
      </div>
      <div class="page-404__img">
        <img src="@/assets/images/404.svg" />
      </div>
      <div v-if="!noPreview" class="page-404__button-wrapper">
        <a @click="$router.go(-1)">
          <Button class="btn_secondary md:mt-12">{{
            $t("page404.button2")
          }}</Button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Eggos from '@/components/Eggos.vue';
import Button from '@/components/Form/BaseButton.vue';

export default {
  name: 'PageError',
  components: {
    Button,
    Eggos,
  },
  props: {
    noPreview: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$store.commit('layout/startLoading');
  },
};
</script>

<style lang="scss" scoped>
.page-404 {
  @apply relative min-h-screen z-10 px-6 flex flex-col justify-start items-center mx-auto;
  max-width: 500px;
  &__logo {
    @apply mt-8;
    img {
      @apply hidden mx-auto;
      @media screen and (min-width: 768px) {
        @apply block mb-8;
      }
    }
  }
  &__title {
    @apply font-bold text-2xl text-left block my-8;
    @media screen and (min-width: 768px) {
      @apply mt-12 text-center text-4xl;
    }
  }
  &__desc {
    @apply text-xl font-bold text-left leading-tight mb-8;
    width: 250px;
    @media screen and (min-width: 768px) {
      @apply text-center text-2xl;
      width: 450px;
    }
  }
  &__img {
    @apply mt-12;
    @media screen and (min-width: 768px) {
      @apply mt-24;
    }
  }
  &__button-wrapper {
    @apply flex justify-start flex-col my-16;
    @media screen and (min-width: 768px) {
      @apply flex-1;
    }
  }
}
</style>
